<script lang="ts">
import { defineComponent, computed, onMounted } from 'vue'
import { useUtilsStore } from '@/stores'

// Enum for theme types
enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
}

export default defineComponent({
  name: 'AuthLayout',
  setup() {
    const useUtils = useUtilsStore()
    const isTheme = computed(() => useUtils.isTheme)

    onMounted(() => {
      const savedTheme = localStorage.getItem('theme') as Theme
      useUtils.toogleTheme(savedTheme || Theme.LIGHT)
    })

    return { isTheme }
  },
})
</script>

<template>
  <div :data-theme="isTheme" class="h-screen flex items-center justify-center">
    <RouterView />
  </div>
</template>

<style></style>
